import { render, staticRenderFns } from "./dialog-privace-police.vue?vue&type=template&id=a5da693a&scoped=true"
import script from "./dialog-privace-police.vue?vue&type=script&lang=js"
export * from "./dialog-privace-police.vue?vue&type=script&lang=js"
import style0 from "./dialog-privace-police.vue?vue&type=style&index=0&id=a5da693a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5da693a",
  null
  
)

export default component.exports